module.exports = __webpack_public_path__ + "static/img/appointment3.d81ce8b.jpg";


//////////////////
// WEBPACK FOOTER
// /src/assets/img/screens/appointment3.jpg
// module id = MEv6
// module chunks = 1